import React from 'react';
import { connect } from 'react-redux';
import { ONBOARDING_STEPS } from '../../consts/consts';
import { selectCanEditOnboarding, selectConfigOnboardingStep } from '../../redux/config/selectors';
import { OnboardingStepInitial } from '../../components/Onboarding/OnboardingSteps/OnboardingStepInitial';
import { OnboardingStepOrganization } from '../../components/Onboarding/OnboardingSteps/OnboardingStepOrganization';
import { OnboardingStepAppearance } from '../../components/Onboarding/OnboardingSteps/OnboardingStepAppearance';
import { OnboardingStepUsers } from '../../components/Onboarding/OnboardingSteps/OnboardingStepUsers';
import { OnboardingStepOrganizationSuccess } from '../../components/Onboarding/OnboardingSteps/OnboardingStepOrganizationSuccess';
import { OnboardingStepDocuments } from '../../components/Onboarding/OnboardingSteps/OnboardingStepDocuments';
import { OnboardingStepOverview } from '../../components/Onboarding/OnboardingSteps/OnboardingStepOverview';
import { OnboardingStepHousingStock } from '../../components/Onboarding/OnboardingSteps/OnboardingStepHousingStock';
import { OnboardingStepOrganizations } from '../../components/Onboarding/OnboardingSteps/OnboardingStepOrganizations';
import { OnboardingStepNotifications } from '../../components/Onboarding/OnboardingSteps/OnboardingStepNotifications';
import { OnboardingStepDataSource } from '../../components/Onboarding/OnboardingSteps/OnboardingStepDataSource';
import { OnboardingStepApi } from '../../components/Onboarding/OnboardingSteps/OnboardingStepApi';
import { OnboardingStepImportUpload } from '../../components/Onboarding/OnboardingSteps/OnboardingStepImportUpload';
import { OnboardingStepOrganizationsUsers } from '../../components/Onboarding/OnboardingSteps/OnboardingStepOrganizationsUsers';
import { OnboardingStepHousingStockSuccess } from '../../components/Onboarding/OnboardingSteps/OnboardingStepHousingStockSuccess';
import { OnboardingStepLocked } from '../../components/Onboarding/OnboardingSteps/OnboardingStepLocked';
import { OnboardingPageWrapper } from '../../components/ui/Layout/OnboardingLayout';

const OnboardingContainer = ({ configOnboardingStep, canEditOnboarding }) => {
  const renderStep = () => {
    if (!canEditOnboarding) {
      return <OnboardingStepLocked />;
    }

    switch (configOnboardingStep) {
      // Initial
      case ONBOARDING_STEPS.INITIAL:
        return <OnboardingStepInitial />;

      // Part 1 Overview
      case ONBOARDING_STEPS.OVERVIEW_ORGANIZATION:
        return <OnboardingStepOverview currentStage={1} />;
      // Part 1 Steps
      case ONBOARDING_STEPS.ORG_CREATE:
        return <OnboardingStepOrganization isInitial={true} />;
      case ONBOARDING_STEPS.ORG_EDIT:
        return <OnboardingStepOrganization />;
      case ONBOARDING_STEPS.APPEARANCE:
        return <OnboardingStepAppearance />;
      case ONBOARDING_STEPS.USERS:
        return <OnboardingStepUsers />;
      case ONBOARDING_STEPS.DOCUMENTS:
        return <OnboardingStepDocuments />;
      case ONBOARDING_STEPS.ORG_SUCCESS:
        return <OnboardingStepOrganizationSuccess />;

      // Part 2 Overview
      case ONBOARDING_STEPS.OVERVIEW_HOUSING_STOCK:
        return <OnboardingStepOverview currentStage={2} />;
      // Part 2 Steps
      case ONBOARDING_STEPS.HOUSING_STOCK:
        return <OnboardingStepHousingStock />;
      case ONBOARDING_STEPS.PARTNERS:
        return <OnboardingStepOrganizations />;
      case ONBOARDING_STEPS.NOTIFICATIONS:
        return <OnboardingStepNotifications />;
      case ONBOARDING_STEPS.DATA_SOURCE_SELECT:
        return <OnboardingStepDataSource />;
      case ONBOARDING_STEPS.API_INFO:
        return <OnboardingStepApi />;
      case ONBOARDING_STEPS.IMPORT_UPLOAD:
        return <OnboardingStepImportUpload />;
      case ONBOARDING_STEPS.PARTNER_USERS:
        return <OnboardingStepOrganizationsUsers />;
      case ONBOARDING_STEPS.HOUSING_STOCK_SUCCESS:
        return <OnboardingStepHousingStockSuccess />;

      default:
        return <OnboardingStepInitial />;
    }
  };

  return <OnboardingPageWrapper>{renderStep()}</OnboardingPageWrapper>;
};

const mapStateToProps = (state) => ({
  configOnboardingStep: selectConfigOnboardingStep(state),
  canEditOnboarding: selectCanEditOnboarding(state)
});

export default connect(mapStateToProps, {})(OnboardingContainer);
